/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-29 18:10:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-12 14:50:50
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/SectionTitle/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import StyledTitle from './StyledTitle';
export { StyledTitle };
const SectionTitle = (props) => {
  const { title, containerClassName } = props;
  return (
    <div className={`${css.container} ${containerClassName || ''}`}>
      {title}
    </div>
  );
};
export default SectionTitle;
